import React from 'react';
import PropTypes from 'prop-types';

import CommonPopup from 'components/common/CommonPopup';

const CommonErrorIcon = props => (
  <CommonPopup
    className="common-error-icon__component"
    errorIcon
    type="error"
  >
    {props.errorText}
  </CommonPopup>
);

CommonErrorIcon.propTypes = {
  errorText: PropTypes.string.isRequired,
};

export default CommonErrorIcon;
